import React from 'react';
import { PageHeader } from '@/components/common/PageHeader';
import { Card, CardContent } from '@/components/ui/card';

const PrivacyPage = () => {
  return (
    <div>
      <PageHeader
        title="Privacy Policy"
        subtitle="How we collect, use, and protect your information"
        breadcrumbs={[
          { label: 'Home', path: '/' },
          { label: 'Privacy Policy' }
        ]}
      />

      <section className="section-padding bg-background">
        <div className="container-custom max-w-4xl">
          <Card>
            <CardContent className="p-8 prose prose-lg max-w-none">
              <p className="text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>

              <h3 className="text-xl font-heading font-bold text-foreground mt-8 mb-4">1. Information We Collect</h3>
              <p className="text-foreground leading-relaxed mb-4">
                We collect personal information that you provide to us such as name, email address, phone number, and academic details when you register for our courses or make enquiries.
              </p>

              <h3 className="text-xl font-heading font-bold text-foreground mt-8 mb-4">2. How We Use Your Information</h3>
              <p className="text-foreground leading-relaxed mb-4">
                We use the information we collect to:
              </p>
              <ul className="list-disc pl-6 text-foreground space-y-2 mb-4">
                <li>Process your admission and enrollment</li>
                <li>Communicate about courses, schedules, and updates</li>
                <li>Provide customer support and respond to inquiries</li>
                <li>Send important notices and academic information</li>
                <li>Improve our services and educational content</li>
              </ul>

              <h3 className="text-xl font-heading font-bold text-foreground mt-8 mb-4">3. Information Sharing</h3>
              <p className="text-foreground leading-relaxed mb-4">
                We do not sell, trade, or rent your personal information to third parties. We may share information with trusted service providers who assist us in operating our institute, conducting our business, or serving our students.
              </p>

              <h3 className="text-xl font-heading font-bold text-foreground mt-8 mb-4">4. Data Security</h3>
              <p className="text-foreground leading-relaxed mb-4">
                We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
              </p>

              <h3 className="text-xl font-heading font-bold text-foreground mt-8 mb-4">5. Your Rights</h3>
              <p className="text-foreground leading-relaxed mb-4">
                You have the right to access, correct, or delete your personal information. You may also opt-out of receiving promotional communications from us.
              </p>

              <h3 className="text-xl font-heading font-bold text-foreground mt-8 mb-4">6. Contact Us</h3>
              <p className="text-foreground leading-relaxed mb-4">
                If you have any questions about this Privacy Policy, please contact us at:
              </p>
              <ul className="list-none text-foreground space-y-1">
                <li>Email: info@mantraprayas.com</li>
                <li>Phone: +91 98765 43210</li>
                <li>Address: Plot No. 45, Sector 12, Bhilwara, Rajasthan</li>
              </ul>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPage;
